module.exports = __webpack_public_path__ + "static/img/guest-mode-popup.e46c67a.png";